import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Footer from './components/Footer';
import UploadHub from './pages/UploadHub';

const App = () => (
  <>
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/:method/:clientId?" component={UploadHub} />
        <Route exact path="/:method/:clientId?" component={UploadHub} />
      </Switch>
    </Router>
    <Footer />
  </>
);

export default App;
